module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/uploaded-file-1ec4202186a38f638654a2448a70a656.svg";